import { RadioGroup, Text } from 'components'
import { AgeLockIcon } from 'components/icons'
import { formTextProps } from '../../utils'
import FormSection from '../FormSection'

interface Props {
  previewMode?: boolean
  colorScheme?: string
  text: string
  value?: string
  onChange: (value: string) => void
}

export default function DisclaimerSection({
  text,
  colorScheme,
  value,
  previewMode,
  onChange,
}: Props) {
  return (
    <FormSection key="disclaimer" previewMode={previewMode}>
      <AgeLockIcon size="lg" />
      <Text {...formTextProps}>{text}</Text>
      <RadioGroup
        value={value}
        options={[{ value: 'yes' }, { value: 'no' }]}
        onChange={onChange}
        textProps={formTextProps}
        colorPalette={colorScheme}
      />
    </FormSection>
  )
}
